import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { Checkbox, RaisedButton } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import MessageBox from '../../generic-components/message-box';
import EmailToPartners from '../../generic-components/email-to-partners';
import EditHistories from '../../generic-components/editHistories';
import {
  addDraftToQueue as addDraftToQueueAction,
} from '../../supplier-updates-queue/__storeFiles__/actions';
import WallWrapper from '../../../wall/wrapper';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const SendUpdates = ({
  sentPartners,
  publishDraft,
  sendUpdatesMessage,
  onRequestClose,
  updateProps,
  sendUpdatesSubject,
  publishingDraft,
  diffSummary,
  isAnAdmin,
  doNotIssueUpdate,
  contractId,
  addDraftToQueue,
}) => {
  const shouldDisableBtns = Boolean(!doNotIssueUpdate && !sendUpdatesMessage) || !(diffSummary && diffSummary.summaryByPage.length);
  return (
    <div>
      <div style={{ padding: '18px' }}>
        <EmailToPartners
          partners={sentPartners.map(partner => ({
            company_name: partner.to.name,
            profileImageUrl: partner.to.avatar,
          }))}
          defaultShowNumOfPartners={8}
        />
        {
          /*
          TODO: fix this
           <Checkbox label="Send a Copy to yourself" labelPosition="before" labelStyle={{ color: 'rgba(0, 0, 0, 0.64)' }} style={{ width: '150px', marginBottom: '16px' }}/>
           */
        }
        <b style={{ color: 'rgba(0, 0, 0, 0.64)' }}>Subject:</b>
        <input
          value={sendUpdatesSubject}
          autoFocus
          onChange={({ target: { value } }) => updateProps({ sendUpdatesSubject: value })}
          style={{ width: '87%', height: '32px', marginLeft: '4px', paddingLeft: '4px' }}
        />
        <MessageBox
          style={{ fontSize: '14px', margin: '24px 0', color: '#616161' }}
          value={sendUpdatesMessage}
          onChange={(value) => updateProps({ sendUpdatesMessage: value })}
          placeholder="To help your partners quickly understand what you've updated, please add a brief note here. We'll include it in the contract's activity feed as well as in the email."
        />
        {
          !isNilOrEmpty(diffSummary) ?
            (
              <EditHistories
                diffSummary={diffSummary}
              />
            ) : <span/>
        }

        {/*<div style={{ marginTop: '12px' }}>*/}
          {/*<Checkbox*/}
            {/*label="Do Not Issue Updates to Buyers"*/}
            {/*style={{ width: '60%', display: isAnAdmin ? 'block' : 'none', fontSize: '12px', margin: 'auto' }}*/}
            {/*checked={doNotIssueUpdate}*/}
            {/*onCheck={() => updateProps({ doNotIssueUpdate: !doNotIssueUpdate })}*/}
          {/*/>*/}
          {/*<div style={{ textAlign: 'center' }}>*/}
            {/*<RaisedButton*/}
              {/*label="Add the Updates to The Queue"*/}
              {/*labelStyle={{ textTransform: 'none' }}*/}
              {/*disabled={Boolean(doNotIssueUpdate || !sendUpdatesMessage)}*/}
              {/*secondary*/}
              {/*onTouchTap={() => addDraftToQueue(contractId)}*/}
            {/*/>*/}
            {/*<FlatButton*/}
              {/*label="Send Updates Now"*/}
              {/*labelStyle={{ textTransform: 'none' }}*/}
              {/*secondary*/}
              {/*loader={publishingDraft}*/}
              {/*disabled={Boolean(!doNotIssueUpdate && !sendUpdatesMessage)}*/}
              {/*style={{*/}
                {/*marginLeft: '16px',*/}
                {/*border: `1px solid ${!doNotIssueUpdate && !sendUpdatesMessage ? '#efefef' : '#00bcd4'}`,*/}
              {/*}}*/}
            {/*/>*/}
          {/*</div>*/}
        {/*</div>*/}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginTop: '8px', flexDirection: 'row-reverse' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <FlatButton
              label="Cancel"
              primary
              onTouchTap={onRequestClose}
            />
            <FlatButton
              label="Send Updates Now"
              labelStyle={{ textTransform: 'none' }}
              secondary
              loader={publishingDraft}
              disabled={shouldDisableBtns}
              style={{
                lineHeight: '33px',
                marginLeft: '16px',
                border: `1px solid ${shouldDisableBtns ? '#efefef' : '#00bcd4'}`,
              }}
              onTouchTap={publishDraft}
            />
          </div>
          <div style={{ width: '50%' }}>
            <Checkbox
              label="Do Not Issue Updates to Buyers"
              style={{ marginBottom: '4px', display: isAnAdmin ? 'block' : 'none', fontSize: '12px' }}
              checked={doNotIssueUpdate}
              onCheck={() => updateProps({ doNotIssueUpdate: !doNotIssueUpdate })}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
              <WallWrapper amazonOrange skipClick>
                <RaisedButton
                  label="Add this draft to the Updates Queue"
                  labelStyle={{ textTransform: 'none' }}
                  disabled={shouldDisableBtns}
                  secondary
                  onTouchTap={() => addDraftToQueue(contractId, sendUpdatesMessage)}
                  style={{ minWidth: '287px', marginRight: '1em' }}
                />
              </WallWrapper>
              <a
                style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '10px', textDecoration: 'underline' }}
                target="__blank"
                href="http://support.tourconnect.com/en/articles/3150458-send-multiple-updates-at-once-with-the-updates-queue"
              >
                What's&nbsp;this?
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ contracting, user }) => {
  const leftNav = contracting.contractActivitiesProducts.get('leftNav');
  return ({
    isAnAdmin: user.get('isAnAdmin'),
    isTemplateDraft: leftNav.get('draftType') === 'template' || leftNav.get('originFrom') !== 'edited',
    originFrom: leftNav.get('originFrom'),
    buyerName: leftNav.get('buyerName'),
    email: leftNav.get('email'),
    buyerProfileImageUrl: leftNav.get('buyerProfileImageUrl'),
    sentPartners: leftNav.get('sentPartners') ? leftNav.get('sentPartners').toJS() : [],
    diffSummary: leftNav.get('diffSummary') ? leftNav.get('diffSummary').toJS() : {},
    // editHistory: leftNav.get('editHistory') ? leftNav.get('editHistory').toJS() : [],
  });
};

export default connect(mapStateToProps, { addDraftToQueue: addDraftToQueueAction })(SendUpdates);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/publish-draft-content/send-updates.jsx